import { useQuery } from "@apollo/client";

import { ProjectReviewVisitV2TeamReportsRoute_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2TeamReportsRoute_GetData(visitId: string) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2TeamReportsRoute_GetDataDocument, {
        variables: { visitId },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const result = loading ? previousData : data;

    return {
        teamReportsData: result?.plannerV2VisitGetById,
        loading,
        error,
    };
}
